import { TablePagination } from "@mui/material";

const MessageGridPagination = ({
    totalCount,
    rowsPerPage,
    page,
    onPageChange,
    onRowsPerPageChange
}) => {
    return (
        <TablePagination
            component="div"
            rowsPerPageOptions={[20, 30, 50,100]}
            count={totalCount+1}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={onPageChange}
            onRowsPerPageChange={(event) => onRowsPerPageChange(parseInt(event.target.value, 10))}
        />
    );
};

export default MessageGridPagination;